(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-scroll-top-lola]').forEach(function (button) {
    var threshold = parseInt(button.getAttribute('data-show-after'), 10) || 400;
    var ticking = false;

    function update() {
      var scrolled = window.scrollY || document.documentElement.scrollTop;
      button.classList.toggle('is-visible', scrolled > threshold);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();

    button.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    });
  });
})();
